// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import Mic from '../Icons/Mic';

import SidebarButton from '../Buttons/SidebarButton';

import { createNewConversation } from '../../actions';
import { setLoadingApp } from '../../actions/session';

const useStyles = makeStyles({
  button: {
    marginTop: 10,
    marginBottom: 16,
  },
  text: {
    marginLeft: 16,
    fontSize: 18,
    maxWidth: 170,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

interface Props {
  history: Object;
  createNewConversation: Function;
  setLoadingApp: Function;
}

const StartCaptionsButton = ({ history, createNewConversation, setLoadingApp }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    location: { pathname },
  } = history;

  const onClick = async e => {
    setLoadingApp(true);
    if (!pathname.includes('/web/transcript')) {
      history.push('/web/transcript');
    }
    await createNewConversation();
  };

  return (
    <SidebarButton className={classes.button} color="blue" icon={<Mic width={36} height={44} />} onClick={onClick}>
      <span className={classes.text}>{t('sidebar.buttons.startCaptions')}</span>
    </SidebarButton>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  createNewConversation,
  setLoadingApp,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StartCaptionsButton));
